import { CUSTOMER } from 'src/Actions/Customers/types';

export const initialState = {
  customerUsers: {},
  offset: 1,
  customersLoading: false,
  subscriptionLicenseList: {},
  customer: {},
  isSingleAccount: false,
  activationKeyDetails: null,
  activationKey: ''
};

const customerReducer = (state = initialState, action) => { //NOSONAR
  switch (action.type) {

    case CUSTOMER.GET_CUSTOMERS: {
      let { offset, sort } = action;
      return {
        ...state,
        offset,
        sort,
        customersLoading: offset === 1 ? true : false,
      }
    }

    case CUSTOMER.GET_CUSTOMER_USERS: {
      return {
        ...state,
      }
    }

    case CUSTOMER.GET_CUSTOMERS_FAILURE: {
      let { error } = action;
      return {
        ...state,
        error,
        customer: error
      }
    }

    case CUSTOMER.GET_CUSTOMER_USERS_SUCCESS: {
      const { customerUsers } = action;
      return {
        ...state,
        customerUsers,
      }
    }

    case CUSTOMER.LOAD_MORE_CUSTOMER_USERS_SUCCESS: {
      const { customerUsers } = action;
      const onyxCustomerSubscriptionDetail_COMBINED = appendList(state.customerUsers?.onyxCustomerSubscriptionDetail, customerUsers.onyxCustomerSubscriptionDetail, "email");
      return {
        ...state,
        customerUsers: { ...customerUsers, onyxCustomerSubscriptionDetail: [...onyxCustomerSubscriptionDetail_COMBINED] },
      }
    }

    case CUSTOMER.GET_ONLINE_CONTACTS_FAILURE:
    case CUSTOMER.GET_CUSTOMER_USERS_FAILURE: {
      let { error } = action;
      return {
        ...state,
        customerUsers: {
          error
        },
        error,
      }
    }

    case CUSTOMER.GET_CUSTOMERS_SUCCESS: {
      let { response } = action;
      let temp = appendList(state.subscriptionList, response.subscriptionLicenseList, 'activationKey');
      let{tempval} = temp.length === 1 ? true : false;
      let isSingleAccount = temp && temp.length > 0 ? (tempval) : false;
      return {
        ...state,
        customersLoading: false,
        customer: response,
        subscriptionList: temp,
        isSingleAccount,
        error: {}
      }
    }

    case CUSTOMER.GET_ACTIVATION_KEY_DETAILS: {
      let { activationKey } = action;
      return {
        ...state,
        activationKey,
        activationKeyDetails: null
      }
    }

    case CUSTOMER.GET_ACTIVATION_KEY_DETAILS_SUCCESS: {
      let { activationKeyDetails } = action;
      return {
        ...state,
        activationKeyDetails
      }
    }
    case CUSTOMER.RESET_CUSTOMER_DATA: {
      return {
        ...state,
        activationKeyDetails: null,
        activationKey: '',
        customerUsers: {},
      }
    }

    case CUSTOMER.GET_ONLINE_CUSTOMERS: {   //NOSONAR
      return {
        ...state,
      }
    }

    case CUSTOMER.GET_ONLINE_CUSTOMERS_SUCCESS: {
      let { onlineCustomers } = action;
      return {
        ...state,
        onlineCustomersLoading: false,
        onlineCustomers,
        onlineCustomersList: onlineCustomers,
      }
    }

    case CUSTOMER.GET_ONLINE_CUSTOMERS_FAILURE: {
      let { error } = action;

      return {
        ...state,
        customersLoading: false,
        customers: {
          customers: error
        },
        customersList: [],
        error,
      }
    }
    
    default: {  //NOSONAR
      return {
        ...state,
      }
    }
  }
};

export const appendList = (stateList = [], newList, key) => { //NOSONAR
  let formattedList = [];
  newList = newList && newList.length > 0 ? newList.filter((i) => i !== null) : [];
  if (stateList.length === 0) {
    formattedList = [...newList];
  } else {
    let a = [...stateList, ...newList];
    const arrayUniqueByKey = [...new Map(a.map(item =>
      [item[key], item])).values()];
    formattedList = arrayUniqueByKey;
  }
  return formattedList;
}

export default customerReducer;
